import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import actions from '../../redux/actions';
import Heading from '../Heading';
import Sidebar from './Sidebar';
import NavButtons from '../NavButtons';
import AgreementList from '../Agreements/AgreementList';

class SelectAgreement extends Component {
  componentWillMount() {
    this.props.resetAgreement();
  }

  handlePrev = () => {
    const { fields } = this.props;

    if (fields.newTeam) {
      this.props.router.push('/create/create-team');
    } else {
      this.props.router.push('/create/select-team');
    }
  };

  render() {
    return (
      <div className="select-agreement side">
        <Heading text="Which agreement do you want to use?" />
        <div className="content">
          <Sidebar fields={this.props.fields} />
          <div className="main">
            <AgreementList type="create" />
          </div>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={this.handlePrev} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
});

const mapDispatchToProps = (dispatch) => ({
  resetAgreement: () => {
    dispatch(actions.selectAgreement(null));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SelectAgreement));



// WEBPACK FOOTER //
// src/components/Create/SelectAgreement.jsx